import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  CROSS_DOMAIN,
  CROSS_OPCO,
  SINGLE_DOMAIN,
} from 'AppSrc/core/components/forms/value-dependency-constants';


const fieldId = 'change-scope-domain';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = null;

const vFParams = {
  fieldTitle: 'Change scope - domain?',
  placeholder: 'Please select',
};

const riskLevelParams = {
  weight: 0.2,
  score: {
    [CROSS_DOMAIN]: 2,
    [CROSS_OPCO]: 4,
    [SINGLE_DOMAIN]: 1,
  },
};

const changeScopeDomain = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_DROPDOWN,
};

export { changeScopeDomain };
